export const typeOfMultiStepReactionDialog = 'typeOfMultiStepReactionDialog';

export const REDUCER_KEY_MULTISTEP_REACTION_DIALOG = 'multiStepReactionDialog';
export const MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW = 'rs/MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW';
export const MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS = 'rs/MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_SUCCESS';
export const MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE = 'rs/MULTISTEP_REACTION_DIALOG_FETCH_PREVIEW_FAILURE';
export const MULTISTEP_REACTION_DIALOG_ADD_PROJECT = 'rs/MULTISTEP_REACTION_DIALOG_ADD_PROJECT';
export const MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS = 'rs/MULTISTEP_REACTION_DIALOG_ADD_PROJECT_SUCCESS';
export const MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE = 'rs/MULTISTEP_REACTION_DIALOG_ADD_PROJECT_FAILURE';
export const MULTISTEP_REACTION_DIALOG_CLEAR_STATE = 'rs/MULTISTEP_REACTION_DIALOG_CLEAR_STATE';
